@if (parentFormGroup.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label
        [class.error]="error" class="label"
        >
        {{ label ? label : 'Choose a date' }}
        @if (isRequired) {
          <span>*&nbsp;</span>
          }:
        @if (labelBadge) { <span class="field-label-badge" data-testid="field-label-badge">{{ labelBadge }}</span> }
      </mat-label>
      }
      <input
        [disabled]="isDisabled"
        [formControlName]="controlName"
        [matDatepicker]="picker"
        [max]="max"
        [min]="min"
        [required]="isRequired"
        autocomplete="false"
        class="input date-input"
        date
        matInput
        placeholder="{{placeholder}}"
        >
      @if (parentFormGroup.controls[this.controlName].status !== 'DISABLED') {
        <mat-icon
          class="suffix-icon"
          matSuffix
          svgIcon="calender-light"
          (click)="picker.open()"
          style="cursor: pointer"
          />
      }
      <mat-datepicker #picker [calendarHeaderComponent]="calendarHeader" xPosition="end"></mat-datepicker>
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>
  }


